import { stripArtifactTags } from './chatArtifactTags';
import { stripLeakedImageTags } from './webImageStrips';

/**
 * 멈추거나 끊긴 답의 '받은 만큼'.
 *
 * 멈춤을 누르거나 연결이 끊겨도 이미 받은 글은 지우지 않는다. 멈춘 답은 서버와 같은 메시지 문서 id
 * (turn_{turnId}_ai)에 stopped: 'user', partial: true 로 저장해 새로고침 뒤에도 같은 표시가 나온다.
 */
export const isChatKeepPartialEnabled = () => (
  !['false', '0', 'off'].includes(String(process.env.REACT_APP_CHAT_KEEP_PARTIAL || '').trim().toLowerCase())
);

// 학습지/PPT 제어 태그·파일 편집 블록·원문 이미지 검색 태그를 지운 화면용 본문.
// 자리표시자 [[image_strip:N]] 은 남긴다 — ProAIMessage 가 그 자리에 스트립을 그린다.
export const stripChatSystemTags = (text) => {
  if (!text) return text;
  return stripLeakedImageTags(stripArtifactTags(text)
    .replace(/```\s*(?:hwpx|office)[-_ ]?edit\s*\n[\s\S]*?\n```/gi, '')
    .replace(/```\s*(?:hwpx|office)[-_ ]?edit\s*(?:\n)?[\s\S]*$/gi, '')
    .replace(/```\s*file[-_ ]?artifact\s*\n[\s\S]*?\n```/gi, '')
    .replace(/```\s*file[-_ ]?artifact\s*(?:\n)?[\s\S]*$/gi, ''));
};

export const keepablePartialText = (text) => String(stripChatSystemTags(text || '') || '').trim();

const PARTIAL_LABELS = {
  user: '여기서 멈췄어요',
  error: '연결이 끊겨 여기까지 받았어요',
  lost: '연결이 끊겨 여기까지 받았어요',
};

/** 받은 만큼만 남은 답이면 그 아래 한 줄 표시 문구, 아니면 null. */
export const partialAnswerLabel = (message) => {
  if (!message || message.streaming || message.partial !== true) return null;
  return PARTIAL_LABELS[message.stopped] || PARTIAL_LABELS.error;
};
